import { AssetType, getLoanById } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { DETAILS_PATH_BY_PRODUCT } from '@/config/config';
import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';

export const LoanProductTypeRedirect = () => {
  const { loanId } = useParams();

  if (!loanId) return <></>;

  const { data: loan } = useCache(getLoanById, { loanId }, { fallbackData: null });

  const navigate = useNavigate();

  useEffect(() => {
    redirectOnProductMismatch();
  }, [loan]);

  const redirectOnProductMismatch = () => {
    if (loan && loan.assetReference) {
      const assetType: AssetType = loan.assetReference[0].type;
      const product = assetType && ApplicationTypeMap.fromAssetType(assetType);
      const currentPath = location.pathname;
      const targetPath = DETAILS_PATH_BY_PRODUCT[product];

      if (product === ApplicationType.CARD && currentPath !== DYNAMIC_PAGE_PATHS.CONSUMER_LOAN) {
        navigate(generatePath(DYNAMIC_PAGE_PATHS.CONSUMER_LOAN, { loanId }), { replace: true });
        return;
      }

      if (assetType && currentPath !== targetPath && loanId) {
        navigate(generatePath(targetPath, { loanId }), { replace: true });
      }
    }
  };

  return <> </>;
};
